
import React from 'react';
import { NavLink } from 'react-router-dom';

import { FiKey } from 'react-icons/fi';
import { CgProfile } from "react-icons/cg";

const NavPage = ({ activeTab, handleTabChange }) => {
  return (
    <div className="button-box p-3 rounded">
      <NavLink
        to="/Settings/Profile"
        className={`d-flex align-items-center p-2 rounded author-link ${activeTab === 'profile' ? 'active1' : ''}`}
        onClick={() => handleTabChange('profile')}
      >
        <CgProfile width={16} height={16} className="me-3 nav-icon" /> Profile
      </NavLink>
      <NavLink
        to="/Settings/UpdatePassword"
        className={`d-flex align-items-center p-2 rounded author-link ${activeTab === 'UpdatePassword' ? 'active1' : ''}`}
        onClick={() => handleTabChange('UpdatePassword')}
      >
        <FiKey width={16} height={16} className="me-3 nav-icon" /> Change Password
      </NavLink>
    </div>
  );
};

export default NavPage;